module.exports = __webpack_public_path__ + "static/media/buttonsounds01.e56e8309.wav";